import { images } from '../constants';

const team = [ 
{
    id: 1, 
    image: images.team1,
    name: 'Jackson Hayes',
    title: 'Lead Driver',
    biography: "Jackson Hayes is a highly skilled and professional lead driver with years of experience in the transportation industry. Dedicated to ensuring safe and reliable rides, Jackson prioritizes passenger comfort and punctuality. His expertise in route optimization and customer service makes every journey smooth and enjoyable.",
    contacts: {
        phone: '111-222-3344',
        email: 'jackson.hayes@example.com',
        website: 'www.jacksonhayes.com',
    }, 
    accounts: {
        facebook: '',
        linkedin: '',
        twitter: '',
        instagram: '',
    },
    experience: {
        intro: 'Key Achievements in Professional Driving:',
        points: [ 
            'Successfully completed thousands of safe trips',
            'Expert in city navigation and traffic management',
            'Top-rated driver with outstanding customer feedback',
            'Trained in advanced defensive driving techniques',
            'Committed to ensuring passenger safety and satisfaction',
        ],
    },
    skills: [
        { id: 1, title: 'Safe Driving', progress: 95 },
        { id: 2, title: 'Customer Service', progress: 90 },
        { id: 3, title: 'Navigation Skills', progress: 85 },
    ],
},
{
    id: 2,
    image: images.team2,
    name: 'Avery Morgan',
    title: 'Operations Coordinator',
    biography: "Avery Morgan is a highly organized and detail-oriented Operations Coordinator with extensive experience in managing taxi dispatch operations. She ensures seamless scheduling, efficient fleet management, and top-notch customer service to keep the business running smoothly.",
    contacts: {
        phone: '222-333-4455',
        email: 'avery.morgan@example.com',
        website: 'www.averymorgan.com',
    },
    accounts: {
        facebook: '',
        linkedin: '',
        twitter: '',
        instagram: '',
    },
    experience: {
        intro: 'Key Achievements in Operations Management:',
        points: [ 
            'Optimized dispatch system for improved efficiency',
            'Reduced wait times with effective scheduling strategies',
            'Implemented customer feedback improvements',
            'Managed fleet maintenance and availability',
            'Enhanced driver communication and coordination',
        ],
    },
    skills: [
        { id: 1, title: 'Fleet Management', progress: 95 },
        { id: 2, title: 'Dispatch Coordination', progress: 90 },
        { id: 3, title: 'Customer Service', progress: 85 },
    ],
},
{
    id: 3,
    image: images.team3,
    name: 'Liam Carter',
    title: 'Senior Driver',
    biography: "Liam Carter is a seasoned and dependable Senior Driver with years of experience in the taxi industry. Known for his professionalism and excellent driving skills, he ensures passengers enjoy a smooth, safe, and comfortable ride. His deep knowledge of city routes and traffic patterns allows for efficient and timely trips.",
    contacts: {
        phone: '333-444-5566',
        email: 'liam.carter@example.com',
        website: 'www.liamcarter.com',
    },
    accounts: {
        facebook: '',
        linkedin: '',
        twitter: '',
        instagram: '',
    },
    experience: {
        intro: 'Key Achievements in Professional Driving:',
        points: [ 
            'Over 10 years of accident-free driving experience',
            'Highly rated by passengers for punctuality and safety',
            'Expert in traffic navigation and route planning',
            'Trained in advanced driving techniques',
            'Provides excellent customer service and assistance',
        ],
    },
    skills: [
        { id: 1, title: 'Defensive Driving', progress: 95 },
        { id: 2, title: 'Customer Service', progress: 90 },
        { id: 3, title: 'City Navigation', progress: 88 },
    ],
},
{
    id: 4, 
    image: images.team4,
    name: 'Sophie Allen',
    title: 'Customer Relations',
    biography: "Sophie Allen is a dedicated Customer Relations specialist, ensuring that every passenger has a smooth and pleasant experience. With her excellent communication skills and problem-solving abilities, she handles customer inquiries, feedback, and service requests with professionalism and care.",
    contacts: {
        phone: '555-666-7788',
        email: 'sophie.allen@example.com',
        website: 'www.sophieallen.com',
    },
    accounts: {
        facebook: '',
        linkedin: '',
        twitter: '',
        instagram: '',
    },
    experience: {
        intro: 'Key Achievements in Customer Relations:',
        points: [ 
            'Resolved over 5,000 customer inquiries efficiently',
            'Improved customer satisfaction ratings by 30%',
            'Developed streamlined booking and support processes',
            'Trained staff in effective communication techniques',
            'Built strong relationships with regular customers',
        ],
    },
    skills: [
        { id: 1, title: 'Customer Service', progress: 95 },
        { id: 2, title: 'Communication Skills', progress: 90 },
        { id: 3, title: 'Problem-Solving', progress: 88 },
    ],
}
];

export default team;